import React, { useState } from 'react';

import useSampleProperties from './useSampleProperties';

// media
function useMostPopularProperties() {
    const [mostPopularProperties, setMostPopularProperties] = useState(useSampleProperties(4));

    // TODO: use hook from Moralis or custom backend to get most popular properties
    /**
     * When called this hook will query the MongodDB database for all the listings
     * and sort them by the number of views they have. It will then return the top
     * 4 listings and show them on the front-end
     * 
     * Unless Moralis DB has an easy way to call the DB from the client then we will need to create an expressJS 
     * server to handle the DB calls.
     */

    return mostPopularProperties;
}

export default useMostPopularProperties;